import React from 'react';

const Loader = ({ company }) => {
  return (
    <div className="fixed inset-0 z-[100] bg-stone-900 flex flex-col items-center justify-center transition-opacity duration-1000">
      <div className="relative flex flex-col items-center animate-pulse">
        <div className="w-32 h-32 md:w-36 md:h-36 mb-8 rounded-full border-2 border-amber-500/60 overflow-hidden flex items-center justify-center bg-stone-800/30 shadow-[0_0_35px_rgba(217,119,6,0.24)] relative z-10">
          <img
            src={company.logo}
            alt="Company Logo"
            className="w-full h-full rounded-full object-cover scale-105"
          />
        </div>

        <h1 className="text-4xl md:text-6xl font-light tracking-widest text-white mb-2 relative z-10">
          {company.name}
        </h1>
        <p className="text-amber-500 tracking-[0.3em] text-sm uppercase relative z-10">
          {company.subtitle}
        </p>

        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 border border-amber-500/30 rounded-full animate-ping opacity-20" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-80 h-80 border border-white/10 rounded-full animate-pulse opacity-10" />
      </div>
    </div>
  );
};

export default Loader;
